import React from 'react';
import cx from 'classnames';

import { makeStyles } from '@material-ui/core/styles';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import Button from '@material-ui/core/Button';
import ZoomInIcon from '@material-ui/icons/ZoomIn';
import ZoomOutIcon from '@material-ui/icons/ZoomOut';
import RotateRightIcon from '@material-ui/icons/RotateRight';
import RotateLeftIcon from '@material-ui/icons/RotateLeft';
import DownloadIcon from '@material-ui/icons/SaveAlt';
import Tooltip from '@material-ui/core/Tooltip';

const useStyles = makeStyles(() => ({
  root: {
    position: 'absolute',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    padding: 5,
    zIndex: 1,
    pointerEvents: 'none',
  },
  topRow: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
  },
  bottomRow: {
    display: 'flex',
    alignItems: 'center',
  },
  rotateButtons: {
    marginLeft: 'auto',
  },
  buttons: {
    pointerEvents: 'all',
  },
}));

interface Props {
  zoomIn: () => void;
  zoomOut: () => void;
  rotateLeft: () => void;
  rotateRight: () => void;
  downloadImage: () => void;
}

export const ImageViewerButtons = ({
  zoomIn,
  zoomOut,
  rotateLeft,
  rotateRight,
  downloadImage,
}: Props) => {
  const styles = useStyles();
  return (
    <div className={styles.root}>
      <div className={styles.topRow}>
        <div className={styles.buttons}>
          <Tooltip title="stáhnout" placement="bottom">
            <Button
              color="secondary"
              variant="contained"
              onClick={downloadImage}
            >
              <DownloadIcon />
            </Button>
          </Tooltip>
        </div>
      </div>

      <div className={styles.bottomRow}>
        <ButtonGroup className={styles.buttons}>
          <Tooltip title="přiblížit" placement="top">
            <Button color="secondary" variant="contained" onClick={zoomIn}>
              <ZoomInIcon />
            </Button>
          </Tooltip>
          <Tooltip title="oddálit" placement="top">
            <Button color="secondary" variant="contained" onClick={zoomOut}>
              <ZoomOutIcon />
            </Button>
          </Tooltip>
        </ButtonGroup>
        <ButtonGroup className={cx(styles.buttons, styles.rotateButtons)}>
          <Tooltip title="otočit vlevo" placement="top">
            <Button color="secondary" variant="contained" onClick={rotateLeft}>
              <RotateLeftIcon />
            </Button>
          </Tooltip>
          <Tooltip title="otočit vpravo" placement="top">
            <Button color="secondary" variant="contained" onClick={rotateRight}>
              <RotateRightIcon />
            </Button>
          </Tooltip>
        </ButtonGroup>
      </div>
    </div>
  );
};
